import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import * as InvHeaderSelectors from 'store/modules/inventoryHeader/selectors';

interface Props {
  className?: string;
  stickyClassName?: string;
  children?: React.ReactNode;
}

export const StickyTopBar: React.FC<Props> = ({ className, stickyClassName, children }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isSticky, setSticky] = useState(false);
  const isMenuOpen = useSelector(InvHeaderSelectors.isMenuOpenSelector);

  const handleScroll = useCallback(() => {
    const topPosition = containerRef.current?.getBoundingClientRect().y ?? 0;
    setSticky(topPosition < 0);
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <div ref={containerRef} className="sticky-top-bar">
      <div
        style={isSticky ? { zIndex: 51 } : undefined}
        className={classNames(className, 'flex justify-center', {
          'fixed top-[80px] left-0 right-0 bg-white': isSticky && !isMenuOpen,
          'fixed top-[130px] left-0 right-0 bg-white': isSticky && isMenuOpen,
          [stickyClassName ?? '']: isSticky,
        })}
      >
        <div className="main w-full max-w-[1280px]">{children}</div>
      </div>
    </div>
  );
};
